import BaseModel from './BaseModel';
export default class VinWonderTicket extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.vinWonderTicketId = data.vinWonderTicketId || undefined;
        this.ticketType = data.ticketType || undefined;
        this.rateCode = data.rateCode || undefined;
        this.refId = data.refId || undefined;
        this.originalPrice = data.originalPrice || 0;
        this.salePrice = data.salePrice || 0;
    }

    export() {
        const result = super.export({
            id: this.id,
            vinWonderTicketId: this.vinWonderTicketId,
            ticketType: this.ticketType,
            rateCode: this.rateCode,
            refId: this.refId,
            originalPrice: parseInt(this.originalPrice),
            salePrice: parseInt(this.salePrice)
        });
        return result
    }
}

export const ticketTypes = [
    {
        value: 'adult',
        text: 'Người lớn'
    },
    {
        value: 'child',
        text: 'Trẻ em'
    },
    {
        value: 'senior',
        text: 'Người cao tuổi'
    }
]